/**
 * 颜色（条件）变化动画
 */
import fvAnimation from "./fvAnimation"
export default class fvColorTransform extends fvAnimation {
    constructor(shape){
        super(shape,"fvColorTransform");
        this.sizeFunction = AsyncFunction("return (" + this.expression+ ") > 0 ? " + this.expression + ":false");
        this.getData();
    }

    async getData(){
        this.result = await this.executionScript(this.sizeFunction);
    }

    run(canvas,value){
        if(value == false) return;
        this.getData();
        // 表达式为真 true  ，color[0] 否则color[1]
        var index = this.result ? 0 : 1; 
        if(this.shape.fctype == "fvLineObj"){
            this.shape.borderColor = this.changeColor[index]; 
            canvas.style.stroke=this.shape.borderColor; 
        }else if(this.shape.fctype == "fvPolylineObj"){
            this.shape.borderColor = this.changeColor[index];
            canvas.style.stroke=this.shape.borderColor;
        }else if(this.shape.fctype == "fvPipeObj"){
            this.shape.outsideColor = this.changeColor[index];
            canvas.style.fill=this.shape.outsideColor;
        }else if(this.shape.fctype=="fvTextObj"){
            this.shape.color=this.changeColor[index];
            canvas.lastElementChild.style.fill=this.shape.color;
        }else if(this.shape.fctype==="fvButtonObj"){
            this.shape.borderColor=this.changeColor[index];
            canvas.parentNode.getElementById(this.shape.registerName).innerHTML=`
            <stop offset="0" stop-color="rgba(0,0,0,0)" fill-opacity="0">
            </stop><stop offset="0.012" stop-color="${this.shape.borderColor}" fill-opacity="1">
            </stop><stop offset="1" stop-color="${this.shape.borderColor}" fill-opacity="1">
            </stop>
            `
            canvas.style.fill=`url(#${this.shape.registerName})`

        }else{
            this.shape.color = this.changeColor[index];
            canvas.style.fill=this.shape.color;
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvColorTransform.js